import React from 'react';
import { Box } from '@mui/material';

interface JobPostsCompanyLogoProps {
  url?: string;
  width?: number;
  height?: number;
}

const JobPostsCompanyLogo = ({
  url,
  width = 100,
  height = 60,
}: JobPostsCompanyLogoProps) => {
  if (!url) return null;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={width}
      height={height}
    >
      <img
        src={url}
        alt="Company logo"
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    </Box>
  );
};

export default JobPostsCompanyLogo;
